import { InjectionToken } from "@angular/core";
import { Observable } from "rxjs";
import { Widget, WidgetSetting, WidgetType, WidgetUserFilter } from "./classes";
import { WidgetComponentService } from "./components/widget/widget/widget-component-service";
import { CustomChartView } from "./components/widget/widget/widget.component";
import { WidgetInnerView } from "./widget-inner";

export const WIDGET_PROVIDER_SERVICE = new InjectionToken<IWidgetProviderService>('WIDGET_PROVIDER_SERVICE');
export const WIDGET_STANDALONE_COMPONENT_SERVICE = new InjectionToken<WidgetComponentService>('WIDGET_STANDALONE_COMPONENT_SERVICE');

export interface IWidgetProviderService {
    chartViews: CustomChartView[];
    iFrameViews: string[];
    widget$: Observable<Widget>;
    widgetType$: Observable<WidgetType>;
    widgetBarPosition: number;
    addChartView(widgetSetting: WidgetSetting);
    addIFrameView(href: string);
    deleteUserFilter(filter: WidgetUserFilter): Observable<Object>;
    deleteWidgetSetting(setting: WidgetSetting): void;
    setSetting(setting: WidgetSetting): Observable<WidgetSetting>;
    setWidgetInnerViews(views: WidgetInnerView[]);
}